import { normalizeLabel } from 'myst-common';
export const mathDirective = {
    name: 'math',
    options: {
        label: {
            type: String,
            alias: ['name'],
        },
    },
    body: {
        type: String,
        required: true,
    },
    run(data) {
        var _a;
        const { label, identifier } = normalizeLabel((_a = data.options) === null || _a === void 0 ? void 0 : _a.label) || {};
        return [
            {
                type: 'math',
                identifier,
                label,
                value: data.body,
            },
        ];
    },
};
